import React from 'react';
import PropTypes from 'prop-types';

import Paragraph from '@marvelapp/marvel-ui/paragraph';
import LogoRow from '@marvelapp/marvel-ui/logo-row';
import Align from '@marvelapp/marvel-ui/align';
import styles from './style/logos.module.css';

export default function Logos({ logos, title }) {
  return (
    <div>
      <Align type="center">
        <Paragraph size="m" color="black">
          {title}
        </Paragraph>
      </Align>
      <div className={styles.flex}>
        <LogoRow
          logos={logos}
          align="center"
          color="black"
          opacity={100}
          spacing="m"
        />
      </div>
    </div>
  );
}

Logos.propTypes = {
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  logos: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.array,
  ]),
};



// WEBPACK FOOTER //
// ./src/components/modules/Logos/index.js